import "esbuild-css-modules-plugin-ns-css:src/App.module.css";

export default {
  "app": "App-module__app_gPMrEW__100"
};
      